export default {
  computed: {
    voucherConfig: function () {
      return window.$feconfig?.voucher?.promotions || []
    }
  },
  methods: {
    getSlotIdForVoucherPromo (promotionId) {
      let res = false
      if (Array.isArray(this.voucherConfig) && this.voucherConfig.length > 1) {
        this.voucherConfig.some(promotion => {
          if (promotion.id.find(id => id === promotionId)) {
            res = promotion.slots_id
            return true
          }
          return false
        })
      }
      return res
    }
  }
}
